/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import './ExperiencesPage.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import ConfirmModal from '../../common/confirm-modal/ConfirmModal';
import LoadingModal from '../../common/loading-modal/LoadingModal';
import { confirmModalTypesValues } from '../../const-values/confirmModalTypes';
import { LoadingOutlined } from '@ant-design/icons';
import {
  setDeleteModalOpened,
  setSelectedTableRow
} from '../../redux/website-experiences-slice/websiteExperiencesSlice';
import CustomEmpty from '../../common/custom-empty/CustomEmpty';
import EditIcon from '../../common/icons/EditIcon';
import getFoundObjByValue from '../../helpers/getFoundObjByValue';
import {
  brandsStatus,
  getBrandsStatusArr
} from '../../const-values/brandsStatus';
import { Tag } from 'antd';
import CustomImage from '../../common/custom-image/CustomImage';
import TrashIcon from '../../common/icons/TrashIcon';
import TitleDescForm from '../../components/title-desc-form/TitleDescForm';
import { getSingleSectionTitlesAction } from '../../redux/section-titles-slice/SectionTitlesSliceThunkApi';
import { setFetchedSingleTitle } from '../../redux/section-titles-slice/SectionTitlesSlice';
import {
  deleteWebsiteExperienceAction,
  getWebsiteExperiencesAction
} from '../../redux/website-experiences-slice/websiteExperiencesSliceThunkApi';
import ExperienceForm from './ExperienceForm';

const ExperiencesPage = () => {
  const dispatch = useDispatch();
  // const mainStore = useSelector((store) => store.websiteExperiences);
  // const {
  //   deleteModalOpened,
  //   isLoadingTableData,
  //   selectedTableRow,
  //   fetchDataCount,
  //   isSubmitting,
  //   fetchedTableData
  // } = mainStore;
  const deleteModalOpened = useSelector(
    (store) => store.websiteExperiences.deleteModalOpened
  );
  const isLoadingTableData = useSelector(
    (store) => store.websiteExperiences.isLoadingTableData
  );
  const selectedTableRow = useSelector(
    (store) => store.websiteExperiences.selectedTableRow
  );
  const fetchDataCount = useSelector(
    (store) => store.websiteExperiences.fetchDataCount
  );
  const isSubmitting = useSelector(
    (store) => store.websiteExperiences.isSubmitting
  );
  const fetchedTableData = useSelector(
    (store) => store.websiteExperiences.fetchedTableData
  );
  const fetchSingleTitleCount = useSelector(
    (store) => store.sectionTitles.fetchSingleCount
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let isMounted = true;

  useEffect(() => {
    if (isMounted) {
      dispatch(
        getSingleSectionTitlesAction({
          filterObj: {
            id: 4
          }
        })
      );
    }

    return () => dispatch(setFetchedSingleTitle(null));
  }, [fetchSingleTitleCount]);

  useEffect(() => {
    if (isMounted)
      dispatch(
        getWebsiteExperiencesAction({
          filterObj: null
        })
      );

    return function () {
      isMounted = false;
    };
  }, [fetchDataCount]);

  const handleDeleteObj = () => {
    if (isMounted && selectedTableRow?.id) {
      const formData = new FormData();
      formData.append('id', selectedTableRow.id);
      dispatch(
        deleteWebsiteExperienceAction({
          dataToBeSubmitted: formData
        })
      );
    }
  };

  const ListItem = (card) => {
    return (
      <div className="item-item">
        <CustomImage src={card?.image} className="item-img-wrapper" />
        <div className="item-content">
          <div
            className="item-details"
            style={{
              display: 'flex',
              gap: 4,
              alignItems: 'center'
            }}
          >
            <p className="name">{card?.title}</p>
          </div>
          <div className="item-btns-wrapper">
            <button
              onClick={() => {
                dispatch(setSelectedTableRow(card));
                dispatch(setDeleteModalOpened(true));
              }}
              style={{
                padding: 0
              }}
              className="btn delete-btn"
            >
              <TrashIcon color="rgba(64, 64, 65, 0.6)" />
              حذف
            </button>
            <button
              style={{
                padding: 0
              }}
              className="btn edit-btn"
              onClick={() => {
                dispatch(setSelectedTableRow(card));
              }}
            >
              <EditIcon color="rgba(64, 64, 65, 0.6)" />
              تعديل
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderList = useMemo(() => {
    return () => {
      if (isLoadingTableData) {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 360
            }}
          >
            <LoadingOutlined />
          </div>
        );
      } else if (fetchedTableData?.length === 0) {
        return (
          <CustomEmpty
            style={{
              minHeight: 642
            }}
          >
            <h3
              style={{
                color: '#40404166',
                marginTop: 18
              }}
            >
              لم تقم بإضافة الخطوات بعد
            </h3>
          </CustomEmpty>
        );
      } else if (fetchedTableData?.length > 0) {
        return (
          <div className="sec-list-wrapper">
            {fetchedTableData.map((item) => {
              return <ListItem key={item.id} {...item} />;
            })}
          </div>
        );
      }
      return null;
    };
  }, [fetchedTableData, isLoadingTableData]);

  return (
    <div className="website-page website-experiences-page">
      <p className="website-title">الموقع الالكترونى</p>
      <p className="page-title">إبدأ تجربتك</p>
      <div className="form-list-wrapper">
        <div className="forms-section">
          <TitleDescForm />
          <ExperienceForm fetchedTableData={fetchedTableData} />
        </div>

        <div className="desc-sec">
          <div className="desc-header">الخطوات</div>
          {renderList()}
        </div>
      </div>

      {/* delete exp modal */}
      <ConfirmModal
        modalTitle=""
        modalOpened={deleteModalOpened}
        modalType={confirmModalTypesValues?.errorModal}
        setModalOpened={(v) => dispatch(setDeleteModalOpened(v))}
        handleAccept={handleDeleteObj}
      >
        <h3>{`هل انت متأكد من الحذف ${selectedTableRow?.name || ''}`}</h3>
      </ConfirmModal>
      {/* end delete exp modal */}

      {(isSubmitting || isLoadingTableData) && <LoadingModal />}
    </div>
  );
};

export default ExperiencesPage;
